var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrizTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6826 36.6602L32.6684 30.8795L14 20.1007V53.222C14 57.663 18.8086 60.4395 22.6564 58.2179L32.6684 52.4371L42.6826 46.6564C46.5304 44.4348 46.5304 38.8819 42.6826 36.6602ZM34.2156 43.4988L29.1882 46.4016L24.1608 49.3043C22.7444 50.123 20.9716 49.0991 20.9716 47.4616V32.1696L29.1882 36.9129L34.2156 39.8156C35.632 40.6344 35.632 42.6801 34.2156 43.4988Z",
    fill: "#00A3A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6826 26.7613L38.3769 29.2468L14 15.13V4.45942C14 2.56935 16.0457 1.38749 17.6832 2.33252L32.6684 10.9867L42.6826 16.7674C46.5304 18.989 46.5304 24.5397 42.6826 26.7613Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrizTv);
export default __webpack_public_path__ + "static/media/BrizTv.f9b761bdc257daec4c070c622db6d53c.svg";
export { ForwardRef as ReactComponent };